/* tslint:disable:variable-name*/
// Reason: fr_CA is required for Facebook login dialog locale to work

const fr_CA = {
    global: {
      footer_text: 'Tous droits réservés &copy; {Year} Keyloop (UK) Limited.',
      start: 'Démarrer',
      relogin: 'Actualisez les connexions',
      next: 'Suivant',
      wait: 'Veuillez patienter',
      messenger: {
        title: 'Connectez-vous à Facebook Messenger',
        app_name: 'Keyloop',
        app_permission_requirements: '',
      },
      lead_ads: {
        title: 'Connectez-vous à Facebook Lead Ads',
        app_name: 'Keyloop - Lead Ads',
        app_permission_requirements: ' <b>et</b> se voir attribuer un rôle dans le compte de publicité',
      },
    },
    stepper: {
      link_account: 'Liez votre compte',
      link_dealer_page: 'Liez la page du concessionnaire',
      complete_process: '',
      step_number: 'Étape',
    },
    landing_page: {
      welcome_text: 'Bienvenue chez Keyloop! Ici, vous pouvez connecter votre page Facebook à notre solution \
                    Keyloop Lead Manager.',
      activation_code_reminder: 'Vous devriez déjà avoir reçu un courriel avec votre code d\'activation. \
                                Sinon, veuillez contacter le \
                                <a href="mailto:dealercare@rapidrtc.com?Subject=ActivationCode" target="_top">\
                                service aux concessionnaires.</a>',
      continue_text: 'Une fois que vous avez votre code d\'activation, cliquez sur Démarrer ci-dessous pour \
                    commencer le processus de configuration.',
    },
    login_page: {
      login_prompt: 'Veuillez cliquer sur le bouton ci-dessous pour vous connecter à Facebook.',
      login_context_reminder: 'Ce compte Facebook devrait avoir un accès administrateur à la page Facebook \
                              de votre concessionnaire{extra_reqs}.',
      login_context_confirmation: 'Vous êtes actuellement connecté à Facebook avec le compte suivant:',
    },
    relogin_page: {
      login_prompt: 'Veuillez cliquer sur le bouton ci-dessous pour vous connecter à Facebook.',
      login_context_reminder: 'Ce compte Facebook devrait avoir un accès administrateur à la page Facebook \
                              de votre concessionnaire{extra_reqs}.',
      login_context_confirmation: 'Actualisation de la connexion effectuée avec le compte Facebook suivant:',
    },
    install_page: {
      install_prompt: 'Veuillez sélectionner la page Facebook à laquelle vous souhaitez que Keyloop accède. \
                      Une fois sélectionnée, veuillez entrer le code d\'activation que vous avez reçu par courriel.',
      choose_page_info_text: 'Sélectionnez une page vers laquelle créer un lien:',
      input_activation_code_info_text: 'Code d\'activation:',
      page_drop_down_hint: 'Sélectionnez la page du concessionnaire',
      add_page_button: 'Ajoutez à cette page',
      error: 'Une erreur s\'est produite lors de l\'activation.',
      error_detail: 'Veuillez vérifier le code appliqué et réessayez. Contactez le \
                     <a class="errorLink" href="mailto:sales@rapidrtc.com?Subject=GenericError" target="_top"> \
                     service aux concessionnaires</a> si cela ne résout pas le problème.',
    },
    finished_page: {
      congrats: 'Félicitations!',
      finished_text: 'Votre page Facebook est maintenant liée à Keyloop.',
    },
    privacy_policy: {
      privacy_policy: 'Privacy Policy',
      p_start: 'DMT Development Systems Group Inc. operating as Keyloop ("Keyloop", "we", "us", \
        and "our") is the builder of {app}(the "App") as a \
        commercial service that is intended to be used by subscribers of certain Keyloop \
        products. This page is used to inform visitors regarding our policies with the \
        collection, use, and disclosure of Personal Information for any users of the App.',
      h_intro: 'Introduction',
      p_intro: 'Keyloop is committed to protecting all personal information that is collected, used \
        and disclosed while conducting its business. This privacy policy("Privacy Policy") \
        describes the practices and procedures employed by Keyloop to safeguard personal \
        information. This Privacy Policy describes the personal information that we collect on \
        this App and may be used or shared by Keyloop to provide you with information, \
        experiences or services. By using our App, you consent to our collection and use of \
        your information as described in this Privacy Policy. This Privacy Policy may change \
        from time to time(see section titled "Changes to our Privacy Policy" below) and your \
        ongoing use of this App will be deemed your acceptance of such changes. \
        <br /> <br /> \
        This Privacy Policy is specific to this App and does not apply to information we \
        collect in any other format or through any other means. This Privacy Policy does \
        not cover information collected by any third - party service provider. \
        <br /> <br /> \
        Below are links to privacy policy of third party service providers used by the App:',
      h_info_collection: 'Information We Collect About You',
      p_info_collection: 'When you use our App, we may collect non - personal information from you in the use of \
        the App. Should you decide to input personal information, we may collect your personal \
        information from you including, but not limited to: your name, title, address, \
        telephone number, email address, name of your business and/or type of business you \
        conduct. \
        <br /> <br /> \
        Should you decide to input information, we may collect information from you including, \
        but not limited to: your name, title, address, telephone number, email address, name \
        of your business and/or type of business you conduct. \
        <br /> <br /> \
        The collection of this information enables Keyloop to better tailor responses to your \
        request for information and to serve its customers.',
      h_info_use: 'How We Use Your Information',
      p_info_use: 'We use information that we collect about you or that you provide to us in the following ways:',
      use_1: 'providing maintenance and on-going support of the Keyloop services;',
      use_2: 'improving our software solutions products;',
      use_3: 'identifying customer opportunities and providing product information; and',
      use_4: 'managing and delivering our business and operations.',
      h_info_disclosure: 'Disclosure of Your Information',
      p_info_disclosure: 'Keyloop does not sell personal information to any third parties except with the \
        consent of the individual. \
        <br /> <br /> \
        Keyloop may share your personal information with third party service providers listed \
        in the introduction of this Privacy Policy. \
        <br /> <br /> \
        Keyloop may also share your personal information with third parties who assist us in \
        providing our services and/or process data on our behalf. These third parties may only \
        use your information for the limited purpose for which they are retained by Keyloop. \
        Some of our third party service providers may be located in jurisdictions outside of \
        the country in which you reside. In this regard, your personal information may be \
        subject to the laws of the foreign jurisdiction and accessible to law enforcement \
        officials by virtue of court order, subpoena or other legal process. \
        <br /> <br /> \
        We may disclose personal information that you provide via this App to the following \
        third parties:',
      disclosure_1: 'Our subsidiaries, affiliates and joint venture partners.',
      disclosure_2: 'Contractors, vendors and service providers we use to support our business and this App.',
      disclosure_3: 'In the event of merger, acquisition, or any form of sale of some or all of our \
        assets, in which case personal information we collect via this App will be among the \
        assets transferred to the buyer.',
      p_info_disclosure_also: 'We may also disclose your personal information to third parties to:',
      disclosure_4: 'Comply with any court order or other legal obligation.',
      disclosure_5: 'Enforce or apply our terms of use and other agreements.',
      disclosure_6: 'Protect the rights, property, or safety of our clients, customers, \
        employees, or others. This includes exchanging information with other companies and \
        organizations for the purposes of fraud protection, information security and other \
        related matters.',
      h_info_protection: 'Protection of Your Information',
      p_info_protection: 'Keyloop has established physical, technical and administrative safeguards to protect \
        personal information against unauthorized access, disclosure, use or modification. \
        Keyloop may export your personal information to another jurisdiction including \
        jurisdictions within the EEA, Canada or the United States. \
        <br /> <br /> \
        Keyloop has implemented processes to address the security measures necessary to \
        protect Keyloop\'s software solutions and applications. Keyloop utilizes current \
        technology to monitor and track these environments and applications. Keyloop \
        continues to invest in ensuring our environments and applications are secure. \
        <br /> <br /> \
        Keyloop will only retain and use personal information as long as is necessary for its \
        business purposes or as required by applicable law.',
      h_age_policy: 'Children Under the Age of 13',
      p_age_policy: 'This App and the nature of our services are not intended for children under 13 years of \
        age. No one under age 13 may provide any personal information to or on the App. If you \
        are under 13, do not attempt to register on the App or send any personal information \
        about yourself to us, including your name, address, telephone number or email address.',
      h_change_policy: 'Changes to Our Privacy Policy',
      p_change_policy: 'Keyloop reserves the right to amend this Privacy Policy at any time, for any reason, \
        without notice, other than the posting of the amended Privacy Policy at this website. \
        You should check our website regularly to view our current Privacy Policy that is in \
        effect and any updates that may have been made to it. The provisions contained herein \
        supersede all previous notices or policies regarding our privacy practices that govern \
        this website. With regard to the most current version, the date this Privacy Policy was \
        last revised is identified at the bottom of this web page.',
	  h_delete_info: 'Deletion of Personal Information',
      p_delete_info: 'Keyloop are required to ensure that your personal information is deleted from the App when \
	  you request that it is.  If you would like us to delete your data please, contact us using the details below.',
	  h_contact_info: 'Contact Information',
      p_contact_info: 'Should you have any questions or comments regarding our privacy policies or practices, \
        please contact us via our toll - free number: +1(204) 927-1800 or by email at privacy@rapidrtc.com.',
      p_last_revised: 'Last revised: 2021-12-06',
    },
};

export default fr_CA;
